// extracted by mini-css-extract-plugin
export var deleteIcon = "_tt-5";
export var deleteOption = "_tt-3";
export var divider = "_tt-2";
export var downloadIcon = "_tt-4";
export var drawer = "_tt-0";
export var drawerFooter = "_tt-6";
export var drawerOpen = "_tt-1";
export var highlighted = "_tt-7";
export var lighterHighlight = "_tt-8";